<template>
  <div id="app">
    <template v-if="pc">
      <header-navgation v-if="pc" ref="navigation"></header-navgation>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <div id="footers">
        <links></links>
        <!-- 底部导航 -->
        <ts-iclass-platform-footer></ts-iclass-platform-footer>
      </div>
      <!-- 右侧浮动窗 -->
      <ts-floating-window mode="light" :urls="urls"></ts-floating-window>
    </template>
    <template v-else>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </template>
  </div>
</template>

<script>

import { setBodyClass } from '../../utils/screen'
import HeaderNavgation from '../../views/official/home/components/HeaderNavgation.vue'
import Links from '../../views/official/intro/components/edition/Links.vue'

export default {
  components: { HeaderNavgation, Links },
  name: 'app',
  data() {
    return {
      urls: {},
      pc: false
    }
  },
  created() {
    this.pc = this.$route.path.indexOf('mobile') === -1
  },
  mounted() {
    setBodyClass('app')
    this.urls = {
      download: '/official/eclass/download',
      apply: '/official/apply/submit'
    }
    console.log(this.urls)
  },
  watch: {
    $route: function () {
      if (this.pc) {
        this.$root.setHeaderBackground()
        document.getElementById('footers').style.position = 'relative'
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }
    }
  }
}
</script>

<style>
@import "../../assets/styles/reset.css";
@import "../../assets/styles/style.css";
@import "../../assets/iconfont/iconfont.css";
@import "../../assets/styles/ie-browser.css";
@import "../../assets/styles/mobile.css";
@import "../../../node_modules/teaching-ui/dist/index.css";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f7f4f8;
}

.its-page-content {
  width: 100%;
  min-height: calc(100% - (80px + 168px));
}

#footers {
  position: relative;
  width: 100%;
  bottom: 0;
  z-index: 1;
}
</style>
